import Vue from 'vue'
import Router from 'vue-router'
import CheckAuth from './router/middleware/checkAuth'
import store from './store/store'

Vue.use(Router)

const routes = [
  {
// =============================================================================
// MAIN LAYOUT ROUTES
// =============================================================================
    path: '',
    component: () => import('./layouts/main/Main.vue'),
    children: [
      {
        path: '/scraping',
        name: 'Scarping',
        component: () => import('./views/scraping'),
        meta: {
          pageTitle: 'Scarping',
          rule: 'editor',
        },
      },
      { 
        path: '/', 
        redirect: {name: 'Brokers'} 
      },
      {
        path: '/brokers',
        name: 'Brokers',
        alias: '/',
        component: () => import('./views/pages/broker/All'),
        meta: {
          pageTitle: 'Brokers',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/add-broker',
        name: 'add-broker',
        component: () => import('./views/pages/broker/Add'),
        meta: {
          pageTitle: 'Add New Broker',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/edit-broker/:brokerID',
        name: 'edit-broker',
        component: () => import('./views/pages/broker/Edit'),
        meta: {
          pageTitle: 'Edit Broker',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/brokers-promos',
        name: 'Brokers Promo Codes',
        component: () => import('./views/pages/promos/PromoCodes'),
        meta: {
          pageTitle: 'Promo Codes',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/brokers-commissions',
        name: 'Commissions',
        component: () => import('./views/pages/brokerCommission/All'),
        meta: {
          pageTitle: 'Broker Commissions',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/brokers-commissions/commissions-view',
        name: 'Commissions - View By Commissions',
        component: () => import('./views/pages/brokerCommission/All'),
        meta: {
          pageTitle: 'Broker Commissions',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
      {
        path: '/brokers-commissions/brokers-view',
        name: 'Commissions - View By Brokers',
        component: () => import('./views/pages/brokerCommission/All'),
        meta: {
          pageTitle: 'Broker Commissions',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },      
      {
        path: '/brokers-commissions/brokers-view/:brokerID',
        name: 'show-broker-commissions',
        component: () => import('./views/components/brokerCommission/BrokerCommissions'),
        meta: {
          pageTitle: 'Show Broker Commissions',
          rule: 'admin',
          middleware: [
            CheckAuth
          ]
        },
      },
    ],
  },
// =============================================================================
// FULL PAGE LAYOUTS
// =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/login',
        name: 'pageLogin',
        component: () => import('@/views/pages/Login.vue'),
        meta: {
          pageTitle: 'Login',
          rule: 'editor'
        }
      },
      {
        path: '/two-factor-auth',
        name: 'twoFactorAuth',
        component: () => import('@/views/pages/TwoFactorAuth.vue'),
        meta: {
          pageTitle: 'Two Factor Authentication Step',
          rule: 'editor'
        }
      },
      {
        path: '/pages/error-404',
        name: 'pageError404',
        component: () => import('@/views/pages/Error404.vue'),
        meta: {
          pageTitle: 'Error 404',
          rule: 'editor'
        }
      },
    ]
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/pages/error-404'
  }
];

function middlewarePipeline (context, middleware, index) {
  const nextMiddleware = middleware[index]

  if(!nextMiddleware){
    return context.next
  }

  return () => {
    const nextPipeline = middlewarePipeline(
      context, middleware, index + 1
    )
    nextMiddleware({ ...context, next: nextPipeline })
  }
}

const router = new Router({
  mode: 'history',
  base: '/',
  routes: routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.pageTitle + ' - Lemon Spaces'
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })

})

export default router
